import { checkIfCompatibleWithBackend } from "@todesktop/client-util";
/**
 * Override and supersede the value for the system theme that has been chosen to use internally.
 * Setting this property to "system" will remove the override and everything will be reset to the OS default. By default themeSource is "system".
 *
 * * Follow OS -\> 'system'
 * * Dark Mode -\> 'dark'
 * * Light Mode -\> 'light'
 * @public
 */
export async function setThemeSource(themeSource) {
    if (checkIfCompatibleWithBackend("nativeTheme:setThemeSource", "1.289.0")) {
        return window["todesktop"].nativeTheme.setThemeSource(themeSource);
    }
}
